import { render } from "./ZNBMredact.vue?vue&type=template&id=270e6569&scoped=true"
import script from "./ZNBMredact.vue?vue&type=script&lang=js"
export * from "./ZNBMredact.vue?vue&type=script&lang=js"

import "./ZNBMredact.vue?vue&type=style&index=0&id=270e6569&lang=scss&scoped=true"
import "./ZNBMredact.vue?vue&type=style&index=1&id=270e6569&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270e6569"]])

export default __exports__